import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Segment, Dropdown, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {transportTypes, providerOrderTypes, providerSequenceTypes} from '../../../common/dictionaries/classification';
import {parseProviders, parseTransportTypes} from '../../../common/util/options';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import Abbreviations from './abbreviations';
import './sequenceConfig.scss';


class SequenceConfig extends Component {
  constructor(props) {
    super(props);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }
  
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ProviderOrdersSequenceConfig, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.loadProviders({'withOrigin': true});
    this.props.getSequenceConfigValues();
  }

  handleTypeChange(event, data) {
    this.props.changeSequenceConfigParameter(data.name, data.value);
    this.props.changeSequenceConfigParameter('sequentialName', '');
    this.props.changeSequenceConfigParameter('abbreviation', '');
  }

  handleNameChange(event, data) {
    this.props.changeSequenceConfigParameter(data.name, data.value);
    this.props.findAbbreviationByName(data.value);
  }

  handleInputChange(event, data) {
    this.props.changeSequenceConfigParameter(data.name, data.value.toUpperCase());
  }

  handleSaveClick() {
    const {sequentialType, sequentialName, abbreviation} = this.props;

    if (!sequentialType || !sequentialName || !abbreviation) {
      this.props.addMessageBoxError('Por favor complete los campos antes de guardar');
      return;
    }

    this.props.saveSequenceConfigValues({sequentialType, sequentialName, abbreviation});
  }

  getSequenceNameOptions() {
    const {sequentialType, providers} = this.props;

    switch (sequentialType) {
      case 'TIPO DE ORDEN':
        return providerOrderTypes;
      case 'TIPO DE TRANSPORTE':
        return parseTransportTypes(transportTypes);
      case 'PROVEEDOR':
        return parseProviders(providers);
      default:
        return [];
    }
  }

  renderAbbreviations() {
    const {loading, providers} = this.props;

    return (
      <Abbreviations loading={loading} providers={providers} />
    );
  }

  renderEditSection() {
    const {loading, loadingProviders, sequentialName, sequentialType, abbreviation} = this.props;

    return (
      <Segment secondary>
        <Grid>
          <Grid.Row>
            <Grid.Column width='3' textAlign='left' verticalAlign='top'>
              <label><strong>Tipo de Parámetro</strong></label>
              <Dropdown fluid selection
                name='sequentialType'
                options={providerSequenceTypes}
                value={sequentialType}
                onChange={this.handleTypeChange}
                disabled={loadingProviders || loading}
              />
            </Grid.Column>
            <Grid.Column width='3' textAlign='left' verticalAlign='top'>
              <label><strong>Valor Equivalente</strong></label>
              <Dropdown fluid selection
                name='sequentialName'
                options={this.getSequenceNameOptions(sequentialType)}
                value={sequentialName}
                onChange={this.handleNameChange}
                disabled={loadingProviders || loading}
              />
            </Grid.Column>
            <Grid.Column width='2' textAlign='left' verticalAlign='top'>
              <label><strong>Abreviatura</strong></label>
              <Input fluid
                id='sequence-abbreviation'
                name='abbreviation'
                maxLength='1'
                value={abbreviation}
                onChange={this.handleInputChange}
                disabled={loadingProviders || loading}
              />
            </Grid.Column>
            <Grid.Column width='8' textAlign='right' verticalAlign='middle'>
              <Button primary disabled={loading} onClick={this.handleSaveClick}>GUARDAR</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }

  render() {
    return (
      <div className='provider-order-sequence-config'>
        <Card fluid className='parameters-edition'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='16' textAlign='left'>
                <h2>Pedidos a Proveedores - Configuración de Secuenciales</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {this.renderEditSection()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        {this.renderAbbreviations()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.providerSequenceConfig.loading,
    'sequentialType': state.providerSequenceConfig.sequentialType,
    'sequentialName': state.providerSequenceConfig.sequentialName,
    'abbreviation': state.providerSequenceConfig.abbreviation,
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
  };
};

const {
  addMessageBoxError,
  loadProviders,
  changeSequenceConfigParameter,
  getSequenceConfigValues,
  saveSequenceConfigValues,
  findAbbreviationByName,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  loadProviders,
  changeSequenceConfigParameter,
  getSequenceConfigValues,
  saveSequenceConfigValues,
  findAbbreviationByName,
  navigateTo,
})(SequenceConfig);
